import React from 'react';
import { UserPlus } from 'lucide-react';
import PortalLoginShell from './PortalLoginShell';

export default function RecruiterLogin() {
  return (
    <PortalLoginShell
      badge="For Partners"
      title="Recruiter Login"
      subtitle="Access your recruiter portal to manage student applications and track commissions."
      expectedRole="recruiter"
      onSuccessPath="/recruiter-dashboard"
      iconBg="bg-tge-navy"
      Icon={UserPlus}
      emailPlaceholder="you@agency.com"
      testidPrefix="recruiter-login"
      footerLink={{
        label: "Don't have a partner account?",
        cta: 'Sign up here',
        path: '/recruiter-signup',
      }}
    />
  );
}
